/**
 * @file Factory for shop-item
 * @author diego.morales@notch-interactive.com
 *
 * @module component/shop-item
 *
 */

import observer from '../libs/observer';
import numberStepper from '../components/number-stepper';

let defaults = {
    shopItemAttr: 'data-shop-item',
    numberStepperAttr: 'data-number-stepper',
    addToCartAttr: 'data-add-to-cart',
    priceAttr: 'data-price',
    titleAttr: 'data-title',
    descriptionAttr: 'data-description'
};

const shopItem = (el, options) => {
    let instance = {},
        stepperInstance,
        currentItemsAmount = 0,
        settings = Object.assign({}, defaults, options),

        saveValue = (data) => {
            currentItemsAmount = data.value;
        },

        delegate = (e) => {
            if (e.target.closest(`[${settings.addToCartAttr}]`)) {
                let tmp = {};

                tmp[el.getAttribute(settings.shopItemAttr)] = {
                    title: el.querySelector(`[${settings.titleAttr}]`).innerHTML,
                    description: el.querySelector(`[${settings.descriptionAttr}]`).innerHTML,
                    amount: currentItemsAmount,
                    price: Number(el.querySelector(`[${settings.priceAttr}]`).innerHTML)
                };

                instance.trigger('addToCart', tmp);

                stepperInstance.reset();

                e.preventDefault();
                e.stopPropagation();
            }
        },

        bindEvents = () => {
            el.addEventListener('click', delegate);
        },

        unbindEvents = () => {
            el.removeEventListener('click', delegate);
        };

    if (!(el instanceof HTMLElement)) {
        return;
    }

    stepperInstance = numberStepper(el.querySelector(`[${settings.numberStepperAttr}]`), {
        validationTimeout: 200
    });
    stepperInstance.on('validated', saveValue);

    // Get initial amount
    currentItemsAmount = stepperInstance.getValue();

    // Add composites
    Object.assign(instance, observer());

    bindEvents();

    // public methods
    instance.setAmountValue = (value) => stepperInstance.setValue(value);

    instance.destroy = () => {
        unbindEvents();
    };

    return instance;
};

export default shopItem;

// Export factory to window
window.DS = window.DS || {};
window.DS.shopItem = shopItem;
